import { render, staticRenderFns } from "./HistoricalData.vue?vue&type=template&id=287ab156"
import script from "./HistoricalData.vue?vue&type=script&lang=js"
export * from "./HistoricalData.vue?vue&type=script&lang=js"
import style0 from "./HistoricalData.vue?vue&type=style&index=0&id=287ab156&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports